export const getPlatformPortalHostname = () =>
  String(process.env.REACT_APP_DOMAIN_URL || "")
    .replace(/^https?:\/\//i, "")
    .split("/")[0]
    .trim()
    .toLowerCase()

export const getCurrentPortalHostname = () => {
  if (typeof window === "undefined") {
    return ""
  }
  return String(window.location.hostname || "").trim().toLowerCase()
}

export const isLocalDevHost = (hostname = getCurrentPortalHostname()) =>
  hostname === "localhost" || hostname === "127.0.0.1"

export const isPlatformPortalHost = (hostname = getCurrentPortalHostname()) => {
  const platformHost = getPlatformPortalHostname()
  return Boolean(platformHost && hostname === platformHost)
}

/** True when the browser is on a tenant portal host (subdomain or custom domain). */
export const shouldResolvePortalTenant = () => {
  const hostname = getCurrentPortalHostname()
  if (!hostname || isLocalDevHost(hostname) || isPlatformPortalHost(hostname)) {
    return false
  }
  return true
}

/** Hostname to forward so API gateway resolves the tenant portal domain. */
export const getTenantPortalHostHeader = () => {
  if (!shouldResolvePortalTenant()) {
    return null
  }
  return getCurrentPortalHostname()
}
